<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.addLoading"
                            v-if="page.isNew && $check(user, ['clients.create'])">Criar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading"
                            v-if="!page.isNew && $check(user, ['clients.update'])">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/casos">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">
                                    Detalhes
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field dense label="Email de acesso" v-model="dataset.data.email"
                                                required outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="CNPJ" v-model="dataset.data.registration"
                                                required v-mask="this.$masks.cnpj" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Número do processo"
                                                v-model="dataset.data.process_number" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Termo legal"
                                                :value="formatDate(dataset.data.legal_term)" @input="updateLegalTerm"
                                                outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Ajuizamento"
                                                :value="formatDate(dataset.data.judgment_at)" @input="updateJudgment"
                                                outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Deferimento"
                                                :value="formatDate(dataset.data.deferment_at)" @input="updateDeferment"
                                                outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Início do prazo de hab/div"
                                                :value="formatDate(dataset.data.start_event_at)"
                                                @input="updateStartEvent" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Fim do prazo de hab/div"
                                                :value="formatDate(dataset.data.end_event_at)" @input="updateEndEvent"
                                                outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Declaração da insolvência"
                                                :value="formatDate(dataset.data.insolvency_at)"
                                                @input="updateInsolvency" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Decretação da liquidação"
                                                :value="formatDate(dataset.data.liquidation_at)"
                                                @input="updateLiquidation" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-file-input dense accept="image/png, image/jpeg" prepend-icon="" outlined
                                                counter :rules="[$rules.fileSize(15)]"
                                                hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                                                label="Banner (destaque)" :clearable="true"
                                                @change="onFileSelected('fileBanner', $event)" ref="logoFile"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))">
                                            </v-file-input>

                                            <template v-if="dataset.data.banner_url">
                                                <v-img @click="openDoc(dataset.data.banner_url)" class="rounded-xl"
                                                    :height="100" :width="100" :src="dataset.data.banner_url"
                                                    :disabled="!page.isNew && (!($check(user, ['clients.update'])))"></v-img>

                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn
                                                            :disabled="!page.isNew && (!$check(user, ['clients.delete.file']))" 
                                                            v-on="on" class="mt-4" type="button" elevation="0"
                                                            color="primary" dark
                                                            @click="deleteFile('banner')"><v-icon>mdi-delete</v-icon>
                                                            Excluir</v-btn>
                                                    </template>
                                                    <span>Excluir banner</span>
                                                </v-tooltip>
                                            </template>
                                        </v-col>

                                        <v-col cols="6">
                                            <v-file-input dense accept="image/png, image/jpeg" prepend-icon="" outlined
                                                counter :rules="[$rules.fileSize(15)]"
                                                hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                                                label="Logo" :clearable="true"
                                                @change="onFileSelected('fileLogo', $event)" ref="logoFile"
                                                :disabled="!page.isNew && (!$check(user, ['clients.delete.file']))">
                                            </v-file-input>

                                            <template v-if="dataset.data.logo_url">
                                                <v-img @click="openDoc(dataset.data.logo_url)" class="rounded-xl"
                                                    :height="100" :width="100" :src="dataset.data.logo_url"></v-img>
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn
                                                            :disabled="!page.isNew && (!$check(user, ['clients.delete.file']))"
                                                            v-on="on" class="mt-4" type="button" elevation="0"
                                                            color="primary" dark
                                                            @click="deleteFile('logo')"><v-icon>mdi-delete</v-icon>
                                                            Excluir</v-btn>
                                                    </template>
                                                    <span>Excluir logo</span>
                                                </v-tooltip>
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <p class="font-weight-bold">Descrição</p>
                                            <tiptap-vuetify v-model="dataset.data.description" :extensions="extensions"
                                                hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['clients.update'])))" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Ações</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-btn v-if="dataset.data.release_status === 1" type="button" elevation="0"
                                    color="accent" class="mr-5" @click="updateStatus(2)"
                                    :disabled="(!($check(user, ['clients.update.allstatus'])))">Liberar casos</v-btn>
                                <v-btn v-else-if="dataset.data.release_status != 1" type="button" elevation="0"
                                    color="error" class="mr-5" @click="updateStatus(1)"
                                    :disabled="(!($check(user, ['clients.update.allstatus'])))">Bloquear casos</v-btn>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


    </v-container>
</template>

<script>
//import states from "@/common/data/states.data"

import { cpf, cnpj } from 'cpf-cnpj-validator'
import axios from "axios"


import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph
} from 'tiptap-vuetify'

import { eventHub } from "@/main";
import releaseStatusInfo from "@/common/data/release-status-info.data.js";

export default {
    name: "ClientDetails",

    components: {
        'tiptap-vuetify': TiptapVuetify,
    },

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        items: [
            { id: null, client_id: null, order: null }
        ],
        editing: false,
        before: null,
        dataset: {
            breadcrumbItems: [],
            // states: states,
            data: {
                judgment_at: null,
                deferment_at: null,
                insolvency_at: null,
                liquidation_at: null,
                end_event_at: null,
                start_event_at: null,
                legal_term: null,
                release_status: null
            },
            loading: false
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Paragraph,
        ],
        releaseStatus: 1,
    }),

    created() {
        this.setPage();
        this.loadData()

        eventHub.$on('DIALOG-CLIENT-DOC-DETAILS', value => {
            this.dialogDocDetails = value;
        });
    },

    methods: {
        goBack() {
            this.$router.replace("/casos");
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Novo Caso" : "Detalhes do caso";
        },

        formatDate(date) {
            if (!date || date === "0000-00-00 00:00:00") return null;
            return this.$moment(date).format('YYYY-MM-DD');
        },

        updateLegalTerm(value) {
            this.dataset.data.legal_term = value;
        },

        updateJudgment(value) {
            this.dataset.data.judgment_at = value;
        },

        updateDeferment(value) {
            this.dataset.data.deferment_at = value;
        },

        updateStartEvent(value) {
            this.dataset.data.start_event_at = value;
        },

        updateEndEvent(value) {
            this.dataset.data.end_event_at = value;
        },

        updateInsolvency(value) {
            this.dataset.data.insolvency_at = value;
        },

        updateLiquidation(value) {
            this.dataset.data.liquidation_at = value;
        },

        refreshPage() {
            window.location.reload();
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            this.listBreadCrumbItems();

            await this.load();
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de casos",
                disabled: false,
                to: "/casos",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: `Detalhes do caso`,
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (!this.$route.params.id) {
                this.goBack()
                return;
            }

            try {
                const result = await axios.get(`/api/clients/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = {
                    ...data,
                    judgment_at: data.judgment_at !== '0000-00-00 00:00:00' ? this.$moment(data.judgment_at).utc(false) : null,
                    deferment_at: data.deferment_at !== '0000-00-00 00:00:00' ? this.$moment(data.deferment_at).utc(false) : null,
                    start_event_at: data.start_event_at !== '0000-00-00 00:00:00' ? this.$moment(data.start_event_at).utc(false) : null,
                    end_event_at: data.end_event_at !== '0000-00-00 00:00:00' ? this.$moment(data.end_event_at).utc(false) : null,
                    legal_term: data.legal_term !== '0000-00-00 00:00:00' ? this.$moment(data.legal_term).utc(false) : null,
                    insolvency_at: data.insolvency_at !== '0000-00-00 00:00:00' ? this.$moment(data.insolvency_at).utc(false) : null,
                    liquidation_at: data.liquidation_at !== '0000-00-00 00:00:00' ? this.$moment(data.liquidation_at).utc(false) : null,
                    release_status: data.release_status,
                };

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            if (!this.$route.params.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o caso?',
                title: 'Atualizar caso',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/admin/clients/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Caso atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateStatus(status) {
            const statusInfo = releaseStatusInfo.find(item => item.id === status);

            if (!statusInfo) {
                this.$dialog.notify.error('Status inválido. Por favor, escolha um valor válido.', {
                    position: 'top-right',
                    timeout: 2000
                });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar o status de todos os casos para "${statusInfo.name}"?`,
                title: `Atualizar status`,
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            });

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.patch('/api/admin/clients/update-all-status', { release_status: Number(status) });

                this.dataset.data.release_status = status;

                this.$dialog.notify.info(`Status atualizado com sucesso para "${statusInfo.name}"!`, {
                    position: 'top-right',
                    timeout: 2000
                });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        buildPayloadStatus() {
            const data = {
                status: this.releaseStatus,
            }

            return data;
        },

        async deleteFile(file) {

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir arquivo',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            try {

                await axios.delete(`/api/admin/clients/${this.$route.params.id}/file/${file}`)

                this.$dialog.notify.info("Arquivo excluído com sucesso", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }

        },

        verifyPendingEvents() {
            if (!this.dataset.data || !this.dataset.data.events) return false;

            const result = this.dataset.data.events.every((x) => x.status != 0);

            return result
        },

        onFileSelected(field, file) {
            this.dataset.data[field] = file;
        },

        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.description)
                formData.append('description', this.dataset.data.description);

            if (this.dataset.data.name)
                formData.append('name', this.dataset.data.name);

            if (this.dataset.data.email)
                formData.append('email', this.dataset.data.email);

            // if (this.dataset.data.state)
            //     formData.append('state', this.dataset.data.state);

            if (this.dataset.data.process_number)
                formData.append('process_number', this.dataset.data.process_number);

            if (this.dataset.data.registration)
                formData.append('registration', this.dataset.data.registration);

            if (this.dataset.data.legal_term)
                formData.append('legal_term', this.$moment(this.dataset.data.legal_term).format('YYYY-MM-DD'));

            if (this.dataset.data.start_event_at)
                formData.append('start_event_at', this.$moment(this.dataset.data.start_event_at).format('YYYY-MM-DD'));

            if (this.dataset.data.end_event_at)
                formData.append('end_event_at', this.$moment(this.dataset.data.end_event_at).format('YYYY-MM-DD'));

            if (this.dataset.data.judgment_at)
                formData.append('judgment_at', this.$moment(this.dataset.data.judgment_at).format('YYYY-MM-DD'));

            if (this.dataset.data.deferment_at)
                formData.append('deferment_at', this.$moment(this.dataset.data.deferment_at).format('YYYY-MM-DD'));

            if (this.dataset.data.insolvency_at)
                formData.append('insolvency_at', this.$moment(this.dataset.data.insolvency_at).format('YYYY-MM-DD'));

            if (this.dataset.data.liquidation_at)
                formData.append('liquidation_at', this.$moment(this.dataset.data.liquidation_at).format('YYYY-MM-DD'));

            if (this.dataset.data.fileLogo)
                formData.append('files[]', this.dataset.data.fileLogo, 'logo')

            if (this.dataset.data.fileBanner)
                formData.append('files[]', this.dataset.data.fileBanner, 'banner')

            return formData;
        },



    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.checkbox-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
</style>